import React from "react";
import Footer from "../../Components/Footer/Footer";

const Helpers = () => {
  const videoData = [
    {
      title: "How to Register & Login",
      description:
        "Step-by-step guide to create a new account & login securely to your account.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_login.mp4?alt=media&token=f0dfe2d5-d970-4d12-a703-65d322ee7940",
    },
    {
      title: "How to Fill all the required Fields",
      description: "Learn how to fill your details on vmb.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_basic.mp4?alt=media&token=cebdb72b-7002-4995-8e67-d0d702fd3e49",
    },
    {
      title: "How to Update Profile",
      description: "Instructions on updating personal details.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_updateprofile.mp4?alt=media&token=f197e178-a4a4-4909-9897-097cc5b51fb1",
    },
    {
      title: "How to Express Interest",
      description: "Send and manage interest requests.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_interest.mp4?alt=media&token=b2c62345-9b6a-4ea8-923a-db8c65003ab4",
    },
    {
      title: "How to Accept Requests & View Profiles",
      description:
        "Understand how to accept incoming interest requests and view the full details of other user profiles.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_acceptuser.mp4?alt=media&token=b650799b-788b-44e5-aa21-16fa36570839",
    },

    {
      title:
        "How to Send Questionnaire Request & View Mutually Accepted Profiles",
      description:
        "Learn how to send a questionnaire to another devotee as part of the match-making process.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_questionarymutual.mp4?alt=media&token=617f94da-f269-48a4-962e-fe0d73bbe277",
    },

    {
      title: "How to View Admin Suggestions",
      description:
        "Discover how to access matches specially recommended by our admin team based on your profile preferences.",
      videoUrl:
        "https://firebasestorage.googleapis.com/v0/b/vaishnava-calendar-69134.appspot.com/o/videos%2Faudio_suggestion.mp4?alt=media&token=38d7b324-55c0-4725-a372-a4049166cf96",
    },
  ];

  return (
    <div className="font-jost flex min-h-screen flex-col bg-gradient-to-b from-gray-100 to-white pt-10">
      <div className="mb-10 text-center">
        <h1 className="text-primary pt-10 text-2xl font-semibold sm:text-3xl lg:text-4xl">
          Learn How to Use the VMB
        </h1>
        <p className="mt-2 text-gray-600">Watch these videos to get started</p>
        <div className="mx-auto mt-2 w-32 border-b-2 border-yellow-400"></div>
      </div>

      <div className="mx-auto grid max-w-6x2 grid-cols-1 gap-8 pb-10 sm:grid-cols-2">
        {videoData.map((video, index) => (
          <div
            key={index}
            className="rounded-xl bg-white p-4 shadow-md transition-all hover:shadow-xl"
          >
            <video
              controls
              className="mb-3 h-64 w-full rounded-md border border-gray-300 object-cover"
            >
              <source src={video.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h2 className="mb-1 text-lg font-bold text-gray-800">
              {video.title}
            </h2>
            <p className="text-sm text-gray-600">{video.description}</p>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Helpers;
